import { createSlice } from '@reduxjs/toolkit';
import { fetchFocusSkuThunk } from './thunk/focusSkuThunk';

const focusSkuSlice = createSlice({
  name: 'focusSku',
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFocusSkuThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFocusSkuThunk.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
      })
      .addCase(fetchFocusSkuThunk.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || action.error;
      });
  },
});

export default focusSkuSlice.reducer;
